import { render, staticRenderFns } from "./DetailMultipleAssignmentsReturn.vue?vue&type=template&id=1ed409ed"
import script from "./DetailMultipleAssignmentsReturn.js?vue&type=script&lang=js&external"
export * from "./DetailMultipleAssignmentsReturn.js?vue&type=script&lang=js&external"
import style0 from "./DetailMultipleAssignmentsReturn.vue?vue&type=style&index=0&id=1ed409ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports